import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

const ScrollToTopLink: React.FC<LinkProps> = ({ children, ...props }) => {
  return (
    <Link {...props}>
      {children}
    </Link>
  );
};

export default ScrollToTopLink; 